export const dispatchFilterChangedEvent = () => {
  window.dispatchEvent(
    new Event("filterChanged", {
      bubbles: true,
      cancelable: true,
      composed: false,
    }),
  );
};
